import { Workspace } from '@nx-frontend/shared/types';
import { WorkspaceAvatar } from '@nx-frontend/shared/types';
import { MenuItemDefault } from '@nx-frontend/shared/types';
import { getBoxFileUrl } from '@nx-frontend/shared/utils';

export type WorkspaceIconSize = 'small' | 'medium' | 'extra-small' | 'font-bold';

export const getWorkspaceImage = (
  workspace: Workspace & { avatarStoredFileUUID?: string },
  workspaceAvatar?: WorkspaceAvatar,
  widthToShow?: number | string,
  heightToShow?: number | string
) => {
  if (!workspace) {
    return null;
  }
  if (workspace.avatarStoredFileUUID) {
    return getBoxFileUrl(workspace.avatarStoredFileUUID, {
      width: widthToShow ? widthToShow : 64,
      height: heightToShow ? heightToShow : 64,
    });
  }
  if (!workspaceAvatar) {
    return null;
  }
  if (!workspaceAvatar.storedFileUUID) {
    return null;
  }
  return getBoxFileUrl(workspaceAvatar.storedFileUUID, {
    width: widthToShow ? widthToShow : 64,
    height: heightToShow ? heightToShow : 64,
  });
};

export function WorkspaceImage({ image }: { image: string }) {
  return <img src={image} width={32} height={32} className="rounded-sm" alt="" />;
}

export const getWorkspaceIcon = (workspace: Workspace, size: WorkspaceIconSize = 'medium') => {
  const workspaceLetter = workspace.title ? workspace.title.slice(0, 2).toUpperCase() : '?';
  if (!['small', 'medium', 'extra-small', 'font-bold'].includes(size)) {
    size = 'medium';
  }
  if (size === 'small') {
    return (
      <div className="bg-neutral-800 flex flex-col justify-center w-4 h-4 text-center rounded-[3px]">
        <span className="text-white text-[8px] font-normal object-center">{workspaceLetter}</span>
      </div>
    );
  }
  if (size === 'extra-small') {
    return (
      <div className="bg-neutral-800 flex flex-col justify-center w-4 h-4 text-center rounded-[2px]">
        <span className="text-white text-[8px] font-normal object-center">{workspaceLetter}</span>
      </div>
    );
  }
  if (size === 'font-bold') {
    return (
      <div className="bg-neutral-800 flex flex-col justify-center w-[36px] h-[36px] text-center items-center rounded-[4px]">
        <span className="text-white text-[12px] object-center">{workspaceLetter}</span>
      </div>
    );
  }

  // medium size
  return (
    <div className="bg-neutral-800 flex flex-col justify-center w-full h-full rounded-[3px]">
      <span className="text-white text-[12px] font-normal object-center">{workspaceLetter}</span>
    </div>
  );
};

/**
 * Mutates workspaceItem.icon property, so it contents workspace image or icon
 * @param workspaceItem
 * @param workspace
 * @param workspaceAvatar
 * @param size
 */
export function setWorkspaceMenuItemIcon(
  workspaceItem: MenuItemDefault,
  workspace: Workspace,
  workspaceAvatar: WorkspaceAvatar | undefined,
  size: WorkspaceIconSize = 'medium'
) {
  const image = getWorkspaceImage(workspace, workspaceAvatar);
  if (image) {
    workspaceItem.icon = <WorkspaceImage image={image} />;
  } else {
    workspaceItem.icon = getWorkspaceIcon(workspace, size);
  }
}
